import {
    PRE_D,
    DUMMY_TIN_FOR_OBH_NON_PROVIDER,
    UMR_POPULATIONS,
    INN_PROVIDER,
    OON_PROVIDER,
    OBH_POPULATIONS,
} from '../constants/index';

/* 
    for future cleanup, if desired, could abstract get_____ForNonProviderProcedure as follows:

    1. consume(popConfig, selectedServiceObj, isOonEstimate, populationsToCheckAgainst)
    2. check if popConfig.sourceCode in the populationsToCheckAgainst && isForPreD
    3. call function that returns based on that if conditional
    4. otherwise return undefined
*/

/**
 * determines the planNetworkCode to send through for nonProviderProcedure cases
 * @param {object} popConfig - the popConfig for this member
 * @param {object} selectedServiceObj - the specific service level information (i.e. CPT billingCode, etc.)
 * @param {boolean} isOonEstimate - if true, is oon. if false, is inn (or at least NOT oon.)
 * @returns {string | undefined} the relevant string if it's for UMR Pre-D, undefined otherwise
 */
export const getPlanNetworkCodeForNonProviderProcedure = (
    popConfig,
    selectedServiceObj,
    isOonEstimate
) => {
    if (
        UMR_POPULATIONS?.includes(popConfig?.sourceCode?.toUpperCase()) &&
        isForPreD(selectedServiceObj, popConfig)
    ) {
        if (isOonEstimate) {
            return OON_PROVIDER;
        } else {
            return INN_PROVIDER;
        }
    }
    return undefined;
};

/**
 * determines the identifiers to send through for nonProviderProcedure cases
 * @param {object} selectedServiceObj - the specific service level information (i.e. CPT billingCode, etc.)
 * @param {object} popConfig - the popConfig for this member
 * @returns {string | undefined} the relevant string if it's for OBH Pre-D, undefined otherwise
 */
export const getIdentifiersForNonProviderProcedure = (selectedServiceObj, popConfig) => {
    if (
        OBH_POPULATIONS?.includes(popConfig?.sourceCode?.toUpperCase()) &&
        isForPreD(selectedServiceObj, popConfig)
    ) {
        /* passing a dummy tin value would not impact OBH Pre-D APIs */
        return DUMMY_TIN_FOR_OBH_NON_PROVIDER;
    }
    return undefined;
};

/**
 * determines if the service will be going to pre-d or not in our pricing service
 * @param {object} selectedServiceObj - the specific service level information (i.e. CPT billingCode, etc.)
 * @param {object} popConfig - the popConfig for this member
 * @returns {boolean} if the service would be processed/estimated for by pre-d, then true. else, false.
 */
export const isForPreD = (selectedServiceObj, popConfig) => {
    const { fullCarePath } = selectedServiceObj;
    const carePathCategoryCode = fullCarePath?.coverageTypeCode;
    const matchedCategory = popConfig?.categoryList?.find((category) => {
        if (category?.categoryType?.toUpperCase() == carePathCategoryCode?.toUpperCase()) {
            return true;
        }
    });
    const rateSource = matchedCategory?.config?.rateSource;
    return rateSource?.toUpperCase() == PRE_D;
};
